import React from 'react';
import { entityManagerProvider } from '../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import { Loader } from '@progress/kendo-react-indicators';

class DashboardStatus extends React.Component<any, any> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      statusResults: [],
      loading: true,
    };
    this.manager = entityManagerProvider.newManager();
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('DashboardStatus');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        statusResults: qr.results,
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  formatter = new Intl.NumberFormat('en-EG', {
    style: 'currency',
    currency: 'EGP',
    maximumFractionDigits: 0,
  });

  render() {
    return (
      <>
        {/* begin::Tiles Widget 1 */}
        <div
          className={`card card-custom bg-radial-gradient-info ${this.props.className}`}
        >
          {/* begin::Header */}
          <div className="card-header border-0 pt-5">
            <h3 className="card-title font-weight-bolder text-white">
              Status Progress
            </h3>
            <div className="card-toolbar"></div>
          </div>
          {/* end::Header */}

          {/* begin::Body */}
          <div className="card-body d-flex flex-column p-0">
            {this.state.loading ? (
              <div className="row" style={{ minHeight: '200px' }}>
                <Loader
                  size="large"
                  style={{ position: 'relative', margin: '60px auto' }}
                  type="converging-spinner"
                />
              </div>
            ) : (
              <>
                <div className="card-spacer bg-white card-rounded flex-grow-1">
                  <div className="row m-0">
                    {this.state.statusResults.map((res, idx) => (
                      <div key={idx} className="col px-8 py-6 mr-8">
                        <div
                          className={`font-size-sm text-muted font-weight-bold`}
                        >
                          {res.name}
                        </div>
                        <div className="font-size-h4 font-weight-bolder">
                          {res.count}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {/* end::Tiles Widget 1 */}
      </>
    );
  }
}

export default DashboardStatus;
